import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["mediaType", "button", "targetPreview", "resultPreview"]
  static values = {
    selectedType: { type: String, default: "video" }
  }

  connect() {
    // Set initial state
    this.selectType(this.selectedTypeValue)
  }

  selectType(type) {
    this.selectedTypeValue = type
    this.mediaTypeTargets.forEach(el => el.textContent = type)
    
    // Update button states
    this.buttonTargets.forEach(button => {
      if (button.dataset.type === type) {
        button.classList.add("bg-white", "text-gray-900")
        button.classList.remove("bg-gray-800", "text-gray-400")
      } else {
        button.classList.remove("bg-white", "text-gray-900")
        button.classList.add("bg-gray-800", "text-gray-400")
      }
    })

    // Show/hide target media and result
    if (type === "GIF") {
      const gifUrl = this.targetPreviewTarget.dataset.gifUrl
      this.targetPreviewTarget.innerHTML = `<img src="${gifUrl}" class="w-full h-full object-cover">`
      const resultGifUrl = this.resultPreviewTarget.dataset.resultGifUrl
      this.resultPreviewTarget.innerHTML = `<img src="${resultGifUrl}" class="w-full h-full object-cover">`
    } else if (type === "photo") {
      const photoUrl = this.targetPreviewTarget.dataset.photoUrl
      this.targetPreviewTarget.innerHTML = `<img src="${photoUrl}" class="w-full h-full object-cover">`
      const resultPhotoUrl = this.resultPreviewTarget.dataset.resultPhotoUrl
      this.resultPreviewTarget.innerHTML = `<img src="${resultPhotoUrl}" class="w-full h-full object-cover">`
    } else if (type === "video") {
      const videoUrl = this.targetPreviewTarget.dataset.videoUrl
      this.targetPreviewTarget.innerHTML = `
        <video autoplay loop muted playsinline class="w-full h-full object-cover">
          <source src="${videoUrl}" type="video/mp4">
        </video>`
      const resultVideoUrl = this.resultPreviewTarget.dataset.resultVideoUrl
      this.resultPreviewTarget.innerHTML = `
        <video autoplay loop muted playsinline class="w-full h-full object-cover">
          <source src="${resultVideoUrl}" type="video/mp4">
        </video>`
    } else {
      this.targetPreviewTarget.innerHTML = ''
      this.resultPreviewTarget.innerHTML = ''
    }
  }

  select(event) {
    const type = event.currentTarget.dataset.type
    this.selectType(type)
  }
} 